import React from 'react'
import { IDEA_STATUS } from '../../store/api/status'

export default class StatusBalls extends React.Component {
    getBallStyles(status) {
        var ballColors = {
            ideate: {
                borderColor: 'var(--secondary)',
                backgroundColor: 'var(--white)',
            },
            accept: {
                borderColor: 'var(--secondary)',
                backgroundColor: 'var(--white)',
            },
            implement: {
                borderColor: 'var(--secondary)',
                backgroundColor: 'var(--white)',
            },
        }

        switch (status) {
            case IDEA_STATUS.OPEN:
                ballColors.ideate = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                break
            case IDEA_STATUS.ACCEPTED:
                ballColors.ideate = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                ballColors.accept = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                break
            case IDEA_STATUS.REJECTED:
                ballColors.ideate = {
                    borderColor: 'var(--secondary)',
                    backgroundColor: 'var(--secondary-light)',
                }
                ballColors.accept = {
                    borderColor: 'var(--secondary)',
                    backgroundColor: 'var(--secondary-light)',
                }
                ballColors.implement = {
                    borderColor: 'var(--secondary)',
                    backgroundColor: 'var(--secondary-light)',
                }
                break
            case IDEA_STATUS.IMPLEMENTED:
                ballColors.ideate = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                ballColors.accept = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                ballColors.implement = {
                    borderColor: 'var(--primary)',
                    backgroundColor: 'var(--primary-light)',
                }
                break
            default:
                break
        }
        return ballColors
    }

    getBallsTooltip(status) {
        var tooltip = ''

        switch (status) {
            case IDEA_STATUS.OPEN:
                tooltip = 'Idea opened for discussion...'
                break
            case IDEA_STATUS.ACCEPTED:
                tooltip = 'Idea accepted. Pending implementation...'
                break
            case IDEA_STATUS.REJECTED:
                tooltip = 'Idea rejected.'
                break
            case IDEA_STATUS.IMPLEMENTED:
                tooltip = 'Idea implemented.'
                break
            default:
                break
        }
        return tooltip
    }

    getBallsLabel(status) {
        var tooltip = ''

        switch (status) {
            case IDEA_STATUS.OPEN:
                tooltip = 'Open'
                break
            case IDEA_STATUS.ACCEPTED:
                tooltip = 'Accepted'
                break
            case IDEA_STATUS.REJECTED:
                tooltip = 'Rejected'
                break
            case IDEA_STATUS.IMPLEMENTED:
                tooltip = 'Implemented'
                break
            default:
                break
        }
        return tooltip
    }

    onClick = (e) => {
        this.props.onClick && this.props.onClick(e.target.id)
    }

    render() {
        var ballStyles = this.getBallStyles(this.props.status)

        return (
            <>
                <div className="status-balls dropdown">
                    <button
                        className="status-button"
                        disabled={this.props.disabled}
                        data-toggle="dropdown"
                        data-toggle-second="tooltip"
                        data-placement="top"
                        title={this.getBallsTooltip(this.props.status)}>
                        <div
                            className="status-ball"
                            style={ballStyles.ideate}
                        />
                        <div
                            className="status-ball"
                            style={ballStyles.accept}
                        />
                        <div
                            className="status-ball"
                            style={ballStyles.implement}
                        />
                    </button>

                    <div className="dropdown-menu" style={{ width: '220px' }}>
                        <button
                            onClick={this.onClick}
                            id={IDEA_STATUS.OPEN}
                            className="dropdown-item"
                            disabled={this.props.status === IDEA_STATUS.OPEN}>
                            Open
                        </button>
                        <button
                            onClick={this.onClick}
                            id={IDEA_STATUS.ACCEPTED}
                            className="dropdown-item"
                            disabled={
                                this.props.status === IDEA_STATUS.ACCEPTED
                            }>
                            Accepted
                        </button>
                        <button
                            onClick={this.onClick}
                            id={IDEA_STATUS.REJECTED}
                            className="dropdown-item"
                            disabled={
                                this.props.status === IDEA_STATUS.REJECTED
                            }>
                            Rejected
                        </button>
                        <button
                            onClick={this.onClick}
                            id={IDEA_STATUS.IMPLEMENTED}
                            className="dropdown-item"
                            disabled={
                                this.props.status === IDEA_STATUS.IMPLEMENTED
                            }>
                            Implemented
                        </button>
                    </div>
                </div>
                <p className="text-secondary text-center mb-0">
                    <small>{this.getBallsLabel(this.props.status)}</small>
                </p>
            </>
        )
    }
}
